import { render, staticRenderFns } from "./PlatformOrderCreationTaoTian.vue?vue&type=template&id=204ed603&scoped=true&"
import script from "./PlatformOrderCreationTaoTian.vue?vue&type=script&lang=js&"
export * from "./PlatformOrderCreationTaoTian.vue?vue&type=script&lang=js&"
import style0 from "./PlatformOrderCreationTaoTian.vue?vue&type=style&index=0&id=204ed603&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204ed603",
  null
  
)

export default component.exports